// css
import styles from './styles.module.scss';

// components
import { Skeleton } from '@mantine/core';
import { Expand } from 'lucide-react';
import GameSimilar from '../GameSimilar';
import GameDescription from '../GameDescription';
import Head from 'next/head';

// hooks
import { useRouter } from 'next/router';
import { useEffect, useRef, useState, useMemo } from 'react';
import fetchGameCover from '@/utils/fetch/fetch.js';
import { useSelector, useDispatch } from 'react-redux';
import { recordCategoryClick } from '@/store/features/gameSlice';

// api
import { getSimilarGames } from '@/api/header';

export default function GameDetail({ game, similarGamesProps }) {
    const { isMobile, categoryClickData } = useSelector((state) => state.game);
    const dispatch = useDispatch();
    const [similarGames, setSimilarGames] = useState(similarGamesProps || []);
    const [loading, setLoading] = useState(!similarGamesProps?.length);
    const iframeRef = useRef(null);

    // 路由跳转
    const router = useRouter();
    const routerPush = (path) => {
        // 确保路径是绝对路径，避免相对路径跳转问题
        const absolutePath = path.startsWith('/') ? path : `/${path}`;
        
        // 如果不是首页路径，记录点击数据到 Redux
        if (absolutePath !== '/') {
            const categoryPath = absolutePath.replace('/', '');
            dispatch(recordCategoryClick({path}));
        }
        
        router.push({ pathname: absolutePath });
    }

    // 生成面包屑结构化数据
    const generateBreadcrumbSchema = (game) => {
        const { currentPath } = categoryClickData;
        const categorie = game.categories?.some((category) => category.slug === currentPath) ? { slug: currentPath } : game.categories?.[0] || null;
        
        if (!categorie) {
            return null; // 如果没有分类，不生成结构化数据
        }

        const itemListElement = [
            {
                "@type": "ListItem",
                "position": 1,
                "name": categorie.slug,
                "item": `https://www.gameyeap.com/${categorie.slug}`
            },
            {
                "@type": "ListItem",
                "position": 2,
                "name": game.slug,
                "item": `https://www.gameyeap.com/game/${game.slug}`
            }
        ];

        return {
            "@context": "https://www.gameyeap.com",
            "@type": "BreadcrumbList",
            "itemListElement": itemListElement
        };
    };



    // 全屏
    const handleMaximize = () => {
        const iframe = iframeRef.current;
        if (iframe.requestFullscreen) {
            iframe.requestFullscreen();
        } else if (iframe.webkitRequestFullscreen) {
            iframe.webkitRequestFullscreen();
        } else if (iframe.mozRequestFullScreen) {
            iframe.mozRequestFullScreen();
        } else if (iframe.msRequestFullscreen) {
            iframe.msRequestFullscreen();
        }
    }



    return (
        <>
            <Head>
                {generateBreadcrumbSchema(game) && (
                    <script 
                        type="application/ld+json"
                        dangerouslySetInnerHTML={{
                            __html: JSON.stringify(generateBreadcrumbSchema(game))
                        }}
                    />
                )}
            </Head>
            
            <div className={`${styles.main_content} ${styles.container}`}>
                {/* 左侧内容区域 */}
                <div className={styles.left_content}>
                    {/* 游戏iframe部分 */}
                    <div className={styles.game_iframe}>
                        <iframe
                            ref={iframeRef}
                            src={game.src}
                            title={game.name}
                            allow="fullscreen; autoplay; camera; microphone; gamepad"
                            allowFullScreen
                        />
                    </div>

                    {/* 按钮栏 */}
                    <div className={styles.iframe_button_group}>
                        <Expand strokeWidth={1.5} size={24} onClick={handleMaximize} className={styles.maxi_mize}/>
                    </div>

                    {/* 底部content区域 */}
                    <div className={styles.content}>
                        {/* 底部左侧 */}
                        <div className={styles.content_left}>
                            {/* 750x100 广告位 */}
                            {/* <div className={styles.ad_slot_banner}>
                                <Skeleton height={100} radius="md" />
                            </div> */}

                            {/* 游戏详情 - 使用统一的 GameDescription 组件 */}
                            <GameDescription game={game} isMobile={false} />
                        </div>

                        {/* 底部右侧 */}
                        {/* <div className={styles.content_right}>
                            <div className={styles.ad_slot_square}>
                                <Skeleton height={300} radius="md" />
                            </div>

                            <div className={styles.ad_slot_tall}>
                                <Skeleton height={750} radius="md" />
                            </div>
                        </div> */}
                    </div>
                </div>

                {/* 右侧推荐游戏区域 */}
                <div className={styles.right_sidebar}>
                    {/* 300x300 广告位 */}
                    {/* <div className={styles.ad_slot_top}>
                        <Skeleton height={300} radius="md" />
                    </div> */}

                    {/* 推荐游戏 */}
                    <div className={styles.recommend_games}>
                        <GameSimilar gameList={similarGames} loading={loading} />
                    </div>
                </div>
            </div>
        </>
    );
} 